<template>
	<el-dialog
		title="新增部门"
		:visible.sync="isShow"
		:close-on-click-modal="false"
		class="default-dialog">
		<el-form ref="form" :model="form" :rules="rulesForm" label-width="80px">
			<el-form-item label="编码：" prop="code">
				<el-input
					size="mini"
					v-model="form.code">
				</el-input>
			</el-form-item>
			<el-form-item label="名称：" prop="name">
				<el-input
					size="mini"
					v-model="form.name">
				</el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
	    	<el-button size="small" class="mg-button-cancel" @click="isShow = false">取 消</el-button>
		    <el-button size="small" type="success" @click="confirm('form')" :disabled="isDisabled">确 定</el-button>
	  	</span>
	</el-dialog>
</template>

<script>

export default {
	props: {
		showVisible: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			form: {
				code: '',
				name: ''
			},
			rulesForm: {
				code: [{
					required: true, message: '请输入编码'
				}],
				name: [{
					required: true, message: '请输入部门名称'
				}]
			},
			isNewlyAdded: false,	// 是否已经新增	
			isDisabled: false		// 手动防止重复请求
		}
	},
	computed: {
		isShow: {
			get () {
				return this.showVisible;
			},
			set (val) {
				this.$emit('update:showVisible', val);
			}
		}
	},
	methods: {
		// 确定保存
		async confirm (formName, status) {
			try {
				let valid = await this.$refs[formName].validate();

				if (valid) {
					this.isDisabled = true;
					try {
						this.$http.post('fixed/adddepartment',this.form).then(res=>{
							this.isNewlyAdded = true;
							this.$emit('isShowAddDepartmentDialog',false);
							this.$emit('onRefresh',true);
							this.$message({
								type: 'success',
								message:res.data.msg,
								showClose: true
							})
						})
					} finally {
						this.$emit('isShowAddDepartmentDialog',false);
						this.isDisabled = false;
					}
				}
			} catch (e) {

			}
		},
	},
	created () {
		
	},
	watch: {
		showVisible (val) {
			if (val) {
				this.isShowDialog = val;
				this.isNewlyAdded = false;
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					this.form = Object.assign({}, this.form, this.$options.data().form);
				})
			} else {
				this.$emit('onRefresh', this.isNewlyAdded);
				setTimeout(() => {
					this.$refs.form.resetFields();
				}, 500)
			}
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialog/AddDepartmentDialog.vue